import * as React from "react";
import { Box, Typography } from "@mui/material";
import AssistantIcon from "@mui/icons-material/Assistant";
import colors from "assets/theme/base/colors";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useState } from "react";
import PromotionModal from "./PromotionModal";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Suggestion } from "types/Dashboard";

type Props = {
  suggestion: Suggestion;
};

const PromotionBanner: React.FC<Props> = ({ suggestion }) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [openSnackBar, setOpenSnackBar] = React.useState(false);

  return (
    <>
      {isModalOpen && (
        <PromotionModal
          open={isModalOpen}
          handleClose={() => setModalOpen(false)}
          addPromotion={(name: string) => {
            setModalOpen(false);
            setOpenSnackBar(true);
          }}
          suggestion={suggestion}
        />
      )}
      <Snackbar
        open={openSnackBar}
        autoHideDuration={5000}
        onClose={() => setOpenSnackBar(false)}
        message="This Snackbar will be dismissed in 5 seconds."
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackBar(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Promotion has created successfully!!
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: colors.info.main, // Orange color
          padding: "8px 16px",
          borderRadius: "20px", // Top-left and bottom-left rounded
          boxShadow: "0px 4px 8px rgba(0,0,0,0.1)"
        }}
      >
        {/* Circular icon button */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "50%",
            width: "48px",
            height: "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "12px",
            padding: 2
          }}
        >
          <AssistantIcon sx={{ color: "#FF9800", fontSize: "24px" }} />
        </Box>
        <MDBox display="flex">
          <MDBox width={"80%"}>
            <Typography
              sx={{ color: "#fff", fontWeight: "bold", fontSize: "18px" }}
            >
              Suggestion!
            </Typography>
            <Typography
              gutterBottom
              sx={{
                color: "#fff",
                fontWeight: 500,
                marginBottom: 1,
                fontSize: "16px"
              }}
            >
              {suggestion.header_title}
            </Typography>
          </MDBox>
          <MDBox
            marginLeft={5}
            width={"20%"}
            display="grid"
            alignItems="center"
          >
            <MDButton
              variant="gradient"
              color="primary"
              fullWidth
              onClick={() => setModalOpen(true)}
              mt={2}
              sx={{
                padding: 2,
                margin: "auto"
              }}
            >
              Create Promotions
            </MDButton>
          </MDBox>
        </MDBox>
      </Box>
    </>
  );
};
export default PromotionBanner;
